<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     消息中心-站内信
  | @Version:   2018-12-10  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="fnc-message-list">
    <div class="filter-container">
      <div class="filter-box"></div>
      <div class="toolbox"><el-checkbox v-model="listQuery.is_read" :true-label="1" :false-label="0" border @change="fetchData(1)">查看未读</el-checkbox></div>
    </div>
    <el-card v-loading="listLoading" shadow="never" class="message-container" :body-style="{ padding: '100px' }">
      <el-collapse v-if="list.length > 0" v-model="activeCollapse" accordion @change="readMessage">
        <el-collapse-item v-for="(item, index) in list" :key="item.id" :name="index">
          <template slot="title">
            <div class="header">
              <span class="status-dot" :class="{ red: item.is_read === 1 }" />
              <span v-if="item.title">{{ item.title }}</span>
              <span v-else>{{ item.message }}</span>
              <span class="time">{{ item.create_time | formatTime }}</span>
            </div>
          </template>
          <div class="content" v-html="item.message" />
        </el-collapse-item>
      </el-collapse>
      <div v-else>
        <p class="text-center text-muted">暂无数据</p>
      </div>
      <el-row style="margin-top: 20px;">
        <el-col :span="24" class="text-right">
          <f-pagination :total="total" :pindex.sync="listQuery.pindex" :psize.sync="listQuery.psize" @change="fetchData" />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { getMessageListApi, readMessageApi } from '@/api/fnc/fncMessageApi'
export default {
  name: 'FncMessageList',
  components: {
  },
  data() {
    return {
      listLoading: false,
      list: [],
      total: 0,
      listQuery: {
        is_read: null,
        pindex: 1,
        psize: 10
      },
      activeCollapse: ''
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(page) {
      if (page) this.listQuery.pindex = page
      this.listLoading = true
      getMessageListApi(this.listQuery).then(res => {
        this.listLoading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        }
      }).catch(err => {
        console.log(err)
      })
    },
    readMessage(index) {
      if (index.length !== 0) {
        const item = this.list[index]
        if (item.is_read === 1) {
          readMessageApi(item.id).then(res => {
            if (!res.errno) {
              this.list[index].is_read = 2
              this.$store.dispatch('getUnreadMessageNum').then((res) => {
              })
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" slot-scoped>
$--color-active-bg: #f5f7fa;
$--color-text-muted: #999999;
$--color-danger: #e64340;
.fnc-message-list {
  .message-container {
    .el-collapse-item {
      .header {
        color: $--color-text-muted;
        font-size: 14px;
        position: relative;
        width: 100%;
        .status-dot {
          width: 6px;
          height: 6px;
          background-color: #999;
          display: inline-block;
          border-radius: 50%;
          margin-right: 7px;
          margin-left: 7px;
          &.red {
            background-color: $--color-danger;
          }
        }
        .title {
          color: inherit;
          margin-left: 10px;
        }
        .time {
          position: absolute;
          right: 20px;
          color: inherit;
        }
      }
      .content {
        padding: 0px 30px;
        margin-bottom: -10px;
        font-size: 14px;
      }
      &.is-active, &:hover {
        .el-collapse-item__header {
          background-color: $--color-active-bg;
        }
        .el-collapse-item__wrap {
          background-color: $--color-active-bg;
        }
      }
      &.is-active {
        .header {
          color: #333;
        }
      }
    }
  }
}
</style>
